<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M42 8H6C4.89543 8 4 8.89543 4 10V38C4 39.1046 4.89543 40 6 40H42C43.1046 40 44 39.1046 44 38V10C44 8.89543 43.1046 8 42 8ZM39.937 14.1713L38.063 11.8287L24.3123 22.8292C24.1297 22.9753 23.8703 22.9753 23.6877 22.8292L9.93704 11.8287L8.06296 14.1713L21.8136 25.1718C23.0918 26.1944 24.9082 26.1944 26.1864 25.1718L39.937 14.1713Z" fill-opacity="0.9"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
